// takes a string and applies a list of string processors to it
export const transform = (html: string, ...transformFunctions: ((html: string) => string)[]) => {
    for (const transform of transformFunctions) {
        html = transform(html);
    }
    return html;
};
